import React, { useId } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@/components/Button/Button';
import tokens from '@/components/AppDialog/tokens.json';

const { LABEL, YES_LABEL, CANCEL_LABEL } = tokens;
interface ConfirmationDialogProps {
  open: boolean;
  onYes: () => void;
  setVisible: (mode: boolean) => void;
  label?: string;
  content?: string;
  yesLabel?: string | React.ReactNode;
  switchLabelTheme?: boolean;
  cancelLabel?: string;
  isCancelable?: boolean;
}
function ConfirmationDialog({
  open,
  setVisible,
  onYes,
  switchLabelTheme = false,
  label = LABEL,
  content,
  yesLabel = YES_LABEL,
  cancelLabel = CANCEL_LABEL,
  isCancelable = true,
}: ConfirmationDialogProps) {
  const dialogId = useId();

  const primaryTheme = switchLabelTheme ? 'primary' : 'error';

  return (
    <Dialog disableEscapeKeyDown open={open} aria-labelledby={dialogId}>
      <DialogTitle id={dialogId} variant="h5" fontWeight="600">
        {label}
      </DialogTitle>
      {content ? (
        <DialogContent>
          <DialogContentText>{content}</DialogContentText>
        </DialogContent>
      ) : null}
      <DialogActions>
        {isCancelable ? (
          <Button
            color={primaryTheme === 'primary' ? 'error' : 'primary'}
            onClick={() => setVisible(false)}
          >
            {cancelLabel}
          </Button>
        ) : null}
        <Button color={primaryTheme} onClick={onYes}>
          {yesLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationDialog;
